/* eslint-disable no-console */
import axios from 'axios';
import moment from 'moment';

import {API_BASE_URL} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {tableAPIMethod, ESGRouteIP} from '../../utils/tableAPIMethod';

const esgAPI = async (
  type: APIType,
  APIRoute: string,
  data: any = undefined,
  tabId: string = '',
  selectedYear: string = '',
  id: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const response: {
      data: {data: {data: Record<string, any>; validationData: any}};
    } = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${APIRoute}/${ESGRouteIP(
        type,
        tabId,
        selectedYear,
        id
      )}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });

    if (type === APITypeEnum.GET_ALL) {
      if (response.data.data?.data) {
        const result = Object.entries(response.data.data?.data).reduce<
          Record<string, moment.Moment | moment.Moment[]>
        >((acc, [key, value]) => {
          if (Array.isArray(value)) {
            const newArray = value.map((rowObj) => {
              if (typeof rowObj === 'object') {
                Object.entries(rowObj).forEach(([arrayKey, arrayValue]) => {
                  if (
                    typeof arrayValue === 'string' &&
                    moment(
                      arrayValue.toString().split('.')[0],
                      'YYYY-MM-DDTHH:mm:ss',
                      true
                    ).isValid()
                  ) {
                    rowObj[arrayKey] = moment(arrayValue);
                  }
                });
              } else if (
                typeof rowObj === 'string' &&
                moment(
                  rowObj.toString().split('.')[0],
                  'YYYY-MM-DDTHH:mm:ss',
                  true
                ).isValid()
              ) {
                rowObj = moment(rowObj);
              }

              return rowObj;
            });

            acc[key] = newArray;
          } else if (
            typeof value === 'string' &&
            moment(
              value.toString().split('.')[0],
              'YYYY-MM-DDTHH:mm:ss',
              true
            ).isValid()
          ) {
            acc[key] = moment(value);
          } else {
            acc[key] = value;
          }

          return acc;
        }, {});

        return {
          ...response.data.data,
          data: result,
          validationData: response.data?.data?.validationData ?? null
        };
      } else {
        return {validationData: response.data?.data?.validationData ?? null};
      }
    } else {
      return response;
    }
  } catch (err) {
    console.log('err:', err);
  }
};

export default esgAPI;
